var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CategoryEncoderConfig_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { Column } from '@symon-ai/wisepipe-common-data';
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import './categoryEncoderColumn'; // force import for JsonSchemaV2
import { ToolCategories } from './toolCategories';
import { ToolConfig } from './toolConfig';
import { ToolConfigInfo } from './toolConfigInfo';
import { ToolScopeBuilder } from './toolScopeBuilder';
import { ToolValidationState } from './validation/toolValidationResult';
import { isSourceValid } from './validation/validateHelper';
import { categoryEncoderConfigSchemaValidation } from '../validations.generated';
export const categoryEncoderConfigSchema = {
    $id: 'urn:wisepipe-common-pipe:CategoryEncoderConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:CategoryEncoderColumn' },
            minItems: 1,
            maxItems: 1000,
            uniqueItemProperties: ['source', 'alias']
        }
    },
    required: ['columns']
};
let CategoryEncoderConfig = CategoryEncoderConfig_1 = class CategoryEncoderConfig extends ToolConfig {
    constructor(columns, customFormats) {
        super(ToolType.CATEGORY_ENCODER, customFormats);
        this.columns = columns;
        JSON.validate(this, CategoryEncoderConfig_1);
    }
    // eslint-disable-next-line class-methods-use-this
    get in() {
        return CategoryEncoderConfig_1.in;
    }
    // eslint-disable-next-line class-methods-use-this
    get out() {
        return CategoryEncoderConfig_1.out;
    }
    // eslint-disable-next-line class-methods-use-this
    get ins() {
        return CategoryEncoderConfig_1.ins;
    }
    // eslint-disable-next-line class-methods-use-this
    get outs() {
        return CategoryEncoderConfig_1.outs;
    }
    static get in() {
        return CategoryEncoderConfig_1.ins[0];
    }
    static get out() {
        return CategoryEncoderConfig_1.outs[0];
    }
    static get ins() {
        return ['default'];
    }
    static get outs() {
        return ['default'];
    }
    static get info() {
        return new ToolConfigInfo(ToolType.CATEGORY_ENCODER.split('_')
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' '), [ToolCategories.CLEAN], this.ins, this.outs, ['LabelEncoder', 'label encoder'], true);
    }
    // eslint-disable-next-line class-methods-use-this
    get hasModel() {
        return true;
    }
    getOutput(iConfigHelper, ins) {
        const tsb = new ToolScopeBuilder(ins);
        const source = ins.schemas.at(this.in);
        const encodes = this.columns.reduce((map, c) => map.set(c.source, c.alias), new Map());
        if (source) {
            const exp = tsb.export(this.out);
            source.forEach((s) => {
                if (encodes.has(s.name)) {
                    exp.encode(s, false).makeNew(new Column(encodes.get(s.name), 'number'), [s], true);
                }
                else {
                    exp.copy(this.in, s, false, false);
                }
            });
            exp.initializeColumnFormats().setColumnFormats(this.customFormats);
        }
        // Encoding categories requires going through the data and a preview on a
        // random sample of records might not be able to accurately illustrate the idea.
        return tsb.build();
    }
    isValidForCalc(iConfigHelper, scope) {
        const source = scope.schemas.at(this.in);
        if (!source) {
            return ToolValidationState.BAD_METADATA;
        }
        const inputs = new Map();
        const outputs = new Set();
        for (const c of this.columns) {
            inputs.set(c.source, ['string', 'number']);
            outputs.add(c.alias);
        }
        return isSourceValid(source, inputs, outputs) ? ToolValidationState.VALID : ToolValidationState.BAD_METADATA;
    }
};
CategoryEncoderConfig = CategoryEncoderConfig_1 = __decorate([
    JsonSchemaV2(categoryEncoderConfigSchema, categoryEncoderConfigSchemaValidation),
    JsonDiscriminatorValue(ToolType.CATEGORY_ENCODER)
], CategoryEncoderConfig);
export { CategoryEncoderConfig };
//# sourceMappingURL=categoryEncoderConfig.js.map